<!--
Copyright 2022 Google Inc. All rights reserved.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->
<template>
  <v-card>
    <div class="pa-8">
      <pre lang="xml" style="font-size: 0.9em">{{ xmlString }}</pre>
    </div>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="close()"> Close </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['xmlString'],
  methods: {
    close: function () {
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss"></style>
